import { Component } from "@angular/core";

@Component({
  selector: "app-auction-layout",
  templateUrl: "./auction-layout.component.html",
  styleUrls: ["./auction-layout.component.scss"],
})
export class AuctionLayoutComponent {}
